import { Grid } from "@mui/material";
import { action, API, controller } from "api";
import { Input, InputPass, MultiSelect, Select } from "controls";
import { ToFormData } from "hooks";
import React, { useEffect, useState } from "react";
import { PassValidation } from "utils";

const AccessAndPermissions = ({
  values,
  errors,
  setErrors,
  passValid,
  fromMyAcc,
  handleInpChg,
  handleInpPass,
}) => {
  const [roles, setRoles] = useState([]);
  const [outlets, setOutlets] = useState([]);

  useEffect(() => {
    API(controller.UserRole + action.GetLabels).get((res) =>
      res?.status === 200
        ? setRoles([...res.result])
        : console.error("User Role Error:", res.msg)
    );

    API(controller.Outlet + action.GetAllByOrg).get((res) => {
      res &&
        res.status === 200 &&
        setOutlets([...res.result.map((j) => ({ ...j, label: j.outletName }))]);
    });
    return () => {};
  }, []);

  const checkUserName = (value) => {
    if (value !== "") {
      API(controller.User + action.IsUsernameExist).post(
        ToFormData({ userId: values.id ? values.id : 0, value: value }),
        (res) => {
          if (res.result) {
            setErrors((j) => ({ ...j, username: res?.msg }));
          }
        }
      );
    }
  };

  return (
    <>
      <Grid item xs={12} className="!mt-[15px]">
        <span className="border-left uppercase font-semibold text-gray-500 pl-[8px]">
          Access & Permissions
        </span>
      </Grid>
      <Grid item xs={12} md={4}>
        <MultiSelect
          label="Outlets"
          name="outletPermissions"
          fullWidth
          value={values.outletPermissions}
          error={errors.outletPermissions}
          onChange={handleInpChg}
          options={outlets}
          enableAddBtn={true}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Select
          label="Role"
          name="roleId"
          required={true}
          error={errors.roleId}
          value={values.roleId}
          onChange={handleInpChg}
          options={roles}
          disabled={fromMyAcc}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Input
          required
          label={"User Name"}
          name="username"
          value={values.username}
          error={errors.username}
          autoComplete="off"
          onChange={handleInpChg}
          onBlur={(e) => checkUserName(e.target.value)}
          fullWidth
          inputProps={{ maxLength: 400 }}
        />
      </Grid>
      {!values.id && (
        <>
          <Grid item xs={12} md={6}>
            <InputPass
              required
              label={"Password"}
              name="password"
              value={values.password}
              onChange={handleInpPass}
              error={errors.password}
              className="input-primary w-100pr"
            />
            <PassValidation {...{ password: values.password, passValid }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputPass
              required
              label="Confirm Password"
              name="confirmPass"
              value={values.confirmPass}
              onChange={(e) => handleInpPass(e, true)}
              error={
                errors.confirmPass !== "" &&
                values.password !== "" &&
                !passValid.match &&
                values.confirmPass !== ""
                  ? "Password and confirm password not match"
                  : errors.confirmPass
              }
              className="input-primary w-100pr"
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default AccessAndPermissions;
